import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';

class FeedbackItem extends React.Component {
    constructor(props) {
        super(props);
        const {title = '', audio = '', feedback_type = '', val = ''} = this.props.node;
        this.state = {
            title: title,
            audio: audio,
            feedback_type: feedback_type,
            val: val,
            visible: false
        };
    }

    componentDidMount(){
        document.addEventListener('jre-text-times-up', this.timesUpEvent);
        document.addEventListener('jre-mt-invisible', this.mtInvisibleEvent);
    }

    hide() {
        this.setState({visible: false});
    }

    show() {
        this.setState({visible: true});
    }

    render() {
        const {moduleURL = ''} = this.props;
        const {val, audio} = this.state;
        return (
            <div>
                <div dangerouslySetInnerHTML={{__html:val}} />
                {audio && <audio ref={audio => this.audio=audio } autoPlay={true} onPlay={this.props.onAudioStart}
                                 onEnded={this.props.onAudioEnded}>
                    <source src={`${moduleURL}/media/${audio}`} />
                </audio>}
            </div>
        );
    }
}

FeedbackItem.propTypes = {
    node: PropTypes.object.isRequired
};

export default withRouter(FeedbackItem);


// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/feedback-item-node.js